export const promoPlatformsEntityTranslationKeys = {
  statisticsPlatformLabel: 'statistics.platform-label',

  promoMediaTypeImage: 'promo.media_type__image',
  promoMediaTypeHTML: 'promo.media_type__html',
  promoMediaTypeGIF: 'promo.media_type__gif',
}
